import { Col, Sheet, Text, useTheme } from "@rally/ui-kit";
import { say } from "../../localization/say.ts";
import { Faces } from "../person/faces.tsx";
import type { Reaction } from "./reacting.ts";
import { everyoneWhoReacted, reactorsInOrder } from "./reaction-names.ts";

const A_FACE_IS = 20;

function OneReaction({ reaction, testID }: { reaction: Reaction; testID: string }) {
  const theme = useTheme();
  const who = reactorsInOrder(reaction.who);

  const me = who.find((one) => one.you)?.account ?? "";
  return (
    <Col
      testID={testID}
      style={{
        flexDirection: "row",
        alignItems: "center",
        gap: theme.space[3],
        paddingVertical: theme.space[2],
      }}
    >
      <Col style={{ flexDirection: "row", alignItems: "center", gap: 4, minWidth: 44 }}>
        <Text style={{ fontSize: 18 }}>{reaction.emoji}</Text>
        <Text typeName="caption" color="text.tertiary">
          {String(reaction.count)}
        </Text>
      </Col>
      <Faces people={who} me={me} size={A_FACE_IS} testID={`${testID}-faces`} />
      <Col style={{ flex: 1, minWidth: 0 }}>
        <Text typeName="caption" color="text.secondary">
          {everyoneWhoReacted(reaction)}
        </Text>
      </Col>
    </Col>
  );
}

export function ReactionSheet({
  visible,
  reactions,
  onDismiss,
  testID,
}: {
  visible: boolean;
  reactions: readonly Reaction[];
  onDismiss: () => void;
  testID: string;
}) {
  return (
    <Sheet visible={visible} onDismiss={onDismiss} title={say("react.everyone")} testID={testID}>
      <Col>
        {reactions.map((one) => (
          <OneReaction key={one.emoji} reaction={one} testID={`${testID}-row-${one.emoji}`} />
        ))}
      </Col>
    </Sheet>
  );
}
